const ip3 = typeof API_BASE_URL === 'string' ? API_BASE_URL : 'https://api.socialkids.vn'; // ip prod mam non
const ip = typeof API_BASE_URL === 'string' ? API_BASE_URL : 'https://api.socialkids.vn'; // ip prod mam non
//const ip3 = API_BASE_URL || 'https://apidevmamnon.aisenote.com'; // ip dev  mam non
//const ip = API_BASE_URL || 'https://apidevmamnon.aisenote.com'; // ip dev mam non
// const ip3 = 'http://192.168.1.55:3000'; // ip dev  mam non
// const ip = 'http://192.168.1.55:3000'; // ip dev mam non
// const ipRedirectLanding = 'http://localhost:3000';
const ipRedirectLanding = typeof REDIRECT_URL === 'string' ? REDIRECT_URL : 'https://socialkids.vn';
// const domainOwn = 'http://localhost:8000';
// const domainOwn = 'https://quantri.socialkids.vn';
//const domainOwn = 'https://slinkmamnon-chinhcd.vercel.app/';
const domainOwn = typeof BACKOFFICE_HOMEPAGE_URL === 'string' ? BACKOFFICE_HOMEPAGE_URL : 'https://quantri.socialkids.vn';

const cameraWSBaseURl = typeof CAMERA_WS_BASE_URL === 'string' ? CAMERA_WS_BASE_URL :  'wss://camstream.socialkids.vn';

const enum ESystemRole {
  SUPER_ADMIN = "SuperAdmin",
  ADMIN = "Admin",
  USER = "User",
  GIAO_VIEN = "GiaoVien",
  HIEU_TRUONG = "HieuTruong",
  PHU_HUYNH = "PhuHuynh",
  GUEST = "Guest",
  CHU_TRUONG = "ChuTruong",
}

export { ip3, ip, ipRedirectLanding, domainOwn, cameraWSBaseURl, ESystemRole };
